import React from "react";
import { IoSearchOutline } from "react-icons/io5";

const SearchFilterSection = ({
  searchTerm,
  setSearchTerm,
  states,
  selectedState,
  setSelectedState,
  cities,
  selectedCity,
  setSelectedCity,
  clearFilters,
  searchTextPlaceholder,
}) => {
  return (
    <React.Fragment>
      <div className="flex flex-col lg:flex-row justify-between items-start md:items-center mb-5 gap-4">
        {/* Search Input */}
        <div className="relative w-full lg:w-96">
          <input
            type="text"
            placeholder={searchTextPlaceholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <IoSearchOutline className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
        </div>

        {/* Filter Section */}
        <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto items-center">
          <p className="text-base">Search by state/province and city:</p>

          {/* State Dropdown */}
          <select
            className="border rounded-md px-4 py-2 text-base bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={selectedState}
            onChange={(e) => {
              setSelectedState(e.target.value);
              setSelectedCity(""); // Reset city when state changes
            }}
          >
            <option value="">Select State/Province</option>
            {states.map((state, index) => (
              <option key={index} value={state}>
                {state}
              </option>
            ))}
          </select>

          {/* City Dropdown */}
          <select
            className="border rounded-md px-4 py-2 text-base bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            // disabled={!selectedState}
          >
            <option value="">Select City</option>
            {cities.map((city, index) => (
              <option key={index} value={city}>
                {city}
              </option>
            ))}
          </select>
          {/* Clear Filters Button */}
          {(selectedCity !== "" ||
            selectedState !== "" ||
            searchTerm !== "") && (
            <button
              className="text-[#284184] px-4 py-2 text-md transition underline"
              onClick={clearFilters}
            >
              Clear Filters
            </button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchFilterSection;
